import React from 'react';
import classNames from 'classnames';
import { InputText, InputTextProps } from 'primereact/inputtext';
import { useController } from 'react-hook-form';
import FormErrorMessage from '../../FormErrorMessage';
import { StaticFormFieldProps } from '../../types/types';

type Props = StaticFormFieldProps & InputTextProps;

export default function TextField({
  name,
  control,
  required,
  rules,
  label,
  help,
  ...rest
}: Props) {
  const { field, fieldState } = useController({
    name: name as string,
    control,
    rules,
  });

  return (
    <div className="field">
      { label && <label htmlFor={field.name} className={classNames({ 'p-error': fieldState.error })}>{label}</label>}
      <InputText {...field} data-testid={field.name} id={field.name} onBlur={field.onBlur} className={classNames({ 'p-invalid': fieldState.error })} {...rest} />
      {help && <span className="form-help">{help}</span> }
      <FormErrorMessage label={fieldState.error?.message} />
    </div>
  );
}
